import * as Yup from "yup";
import {FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as modificationPackageFormNames from "./modificationPackageFormNames";

export const modificationPackageValidationSchema = Yup.object().shape({
  [modificationPackageFormNames.STATUS_PACKAGE_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [modificationPackageFormNames.DESCRIPTION_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
});
